import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

import { FieldEditChangedArgs, FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class ContractSaleForm extends CerFormAdapter {

  private userId: number;

  public override viewSetInit(viewSet: CerFormViewSet) {
    this.userId = this.context.session.user.id();
    viewSet.viewAdd(this.viewGet());
  }

  private viewGet(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'kontrakter-solgte', dataApiName: 'ContractSale',
        primaryKey: 'num', titleFields: ['name'], baseFields: ['id', 'history']
      },
      fieldMetadata: [
        { name: 'num', text: 'Kontrakt', allowEdit: false, allowEditOnAdd: false, visibleAdd: false, orderBy: 'Descending', orderByPriority: 1 },
        { name: 'name', text: 'Titel', tooltipText: 'Navn på kontrakt', widthType: FieldWidthEnum.L },
        { name: 'scope', text: 'Rettigheder', tooltipText: 'Rettigheder til marked', widthType: FieldWidthEnum.L },
        { name: 'counterPartyName', text: 'Forlag', onEditChanged: (e) => this.onCounterPartyNameChanged(e) },
        { name: 'counterPartyContact', text: 'Forlag kontaktperson' },
        { name: 'agentPartyName', text: 'Agent', visible: false, visibleAdd: false, visibleEdit: false },
        { name: 'documentLibPath', text: 'Folder vedhæftninger', defaultValue: '' },
        { name: 'authors', text: 'Forfatter(e)' },
        { name: 'illustrators', text: 'Illustrator(er)' },
        { name: 'genre', text: 'Genre' },
        { name: 'responsible', text: 'Ansvarlig', fieldType: 'user', defaultValue: this.userId },
        { name: 'legacyId', text: 'Opr. id', format: 'Number', visible: false, visibleAdd: false, visibleEdit: false },
        { name: 'created', text: 'Oprettet', format: 'DateShort', defaultValue: new Date(), allowEdit: false, allowEditOnAdd: true },
        { name: 'createdBy', text: 'Oprettet af', fieldType: 'user', defaultValue: this.userId, visible: false, allowEdit: false, allowEditOnAdd: true },
        { name: 'closed', text: 'Lukket dato', format: 'DateShort', visibleAdd: false, allowEditOnAdd: false },
        { name: 'closedBy', text: 'Lukket af', fieldType: 'user', visible: false, visibleAdd: false, allowEditOnAdd: false }
      ],
      fieldGroupMetadata: [
        { idx: 1, name: 'identification', text: 'Identifikation', fields: ['id', 'num', 'name', 'scope', 'counterPartyName', 'counterPartyContact', 'agentParty' ] },
        { idx: 1, name: 'setup', text: 'Opsætning', fields: ['documentLibFolder', 'authors', 'illustrators', 'genre', 'responsible'] },
        { idx: 4, name: 'status', text: 'Status', fields: ['created', 'createdBy', 'closed', 'closedBy'] },
        { idx: 4, name: 'other', text: 'Øvrige', fields: [] }
      ]
    });
  }

  private onCounterPartyNameChanged(e: FieldEditChangedArgs): void {
    var nameValue: string = e.value;
    if (nameValue?.length > 0) {
      var pathInput = e.editService?.fieldInput('documentLibPath');
      if (pathInput && !(pathInput.value?.length > 0)) {
        e.editService?.inputValueSet(pathInput, nameValue);
      }
    }
  }
}
